import api from './api'
import type {
  ConteudoPublicado,
  ConteudoPublicadoEdicaoRequest,
  ConteudoPublicadoRequest,
  ConteudoResumo,
  NovaVersaoConteudoRequest,
} from '@/types/conteudo'

/**
 * Materiais publicados (A12, Onda 7.2). O escopo de leitura de `vigentes` é do backend
 * (perfil do token + tenant); o download do arquivo é pelo `documentoService.baixarArquivo`
 * — endpoint auditado — nunca por URL do storage. O interceptor de `api` devolve o corpo.
 */
const BASE_URL = '/api/v1/conteudos'

export const conteudosService = {
  /** Administrador: todas as peças, ativas ou não, mais recentes primeiro. */
  listar: async (): Promise<ConteudoPublicado[]> => {
    const lista = await api.get<ConteudoPublicado[]>(BASE_URL)
    return (lista as unknown as ConteudoPublicado[]) ?? []
  },

  resumo: async (): Promise<ConteudoResumo> => {
    return (await api.get<ConteudoResumo>(`${BASE_URL}/resumo`)) as unknown as ConteudoResumo
  },

  /** Qualquer autenticado: só o que o perfil e o tenant de quem chama podem ler, vigente hoje. */
  vigentes: async (produtoId?: string): Promise<ConteudoPublicado[]> => {
    const sufixo = produtoId ? `?produtoId=${encodeURIComponent(produtoId)}` : ''
    const lista = await api.get<ConteudoPublicado[]>(`${BASE_URL}/vigentes${sufixo}`)
    return (lista as unknown as ConteudoPublicado[]) ?? []
  },

  publicar: async (request: ConteudoPublicadoRequest): Promise<ConteudoPublicado> => {
    return (await api.post<ConteudoPublicado>(BASE_URL, request)) as unknown as ConteudoPublicado
  },

  atualizar: async (
    id: string,
    request: ConteudoPublicadoEdicaoRequest
  ): Promise<ConteudoPublicado> => {
    return (await api.put<ConteudoPublicado>(
      `${BASE_URL}/${id}`,
      request
    )) as unknown as ConteudoPublicado
  },

  alterarStatus: async (id: string, ativo: boolean): Promise<ConteudoPublicado> => {
    return (await api.patch<ConteudoPublicado>(`${BASE_URL}/${id}/status`, {
      ativo,
    })) as unknown as ConteudoPublicado
  },

  /** Novo arquivo = novo registro com `versao + 1`; o anterior fica `ativo=false`. */
  novaVersao: async (id: string, request: NovaVersaoConteudoRequest): Promise<ConteudoPublicado> => {
    return (await api.post<ConteudoPublicado>(
      `${BASE_URL}/${id}/nova-versao`,
      request
    )) as unknown as ConteudoPublicado
  },
}
